import classnames from 'classnames';
import Markdown from 'markdown-to-jsx';
import * as React from 'react';

import { ChatMessageTypes, ChatMessageTypesClassMap } from '../../store';

export interface ImageMessageContent {
	src: string;
	alt: string;
	text?: string;
}

interface ImageMessageProps {
	imageData: ImageMessageContent;
}

export const dataTestId = `${
	ChatMessageTypesClassMap[ChatMessageTypes.Image]
}-message`;

export const ImageMessage: React.FC<ImageMessageProps> = ({ imageData }) => {
	const { src, alt, text } = imageData;

	return (
		<div
			data-testid={dataTestId}
			className="c-chat-image max-w-85pc border-gray-40 self-start mx-2 mb-2 text-sm break-words bg-white border border-solid rounded-md rounded-tl-none"
		>
			<img
				className={classnames('block', {
					'rounded-md rounded-tl-none': !text,
					'rounded-tr-md': text,
				})}
				src={src}
				alt={alt}
			/>

			{text && (
				<div className="text-body-sm px-3 py-2 whitespace-pre-line">
					<Markdown>{text}</Markdown>
				</div>
			)}
		</div>
	);
};

export default ImageMessage;
